import React, { useEffect, useContext, useState } from 'react';
import styled, { css } from 'styled-components/macro';
import { Redirect } from 'react-router';
import { useSelector } from 'react-redux';
import Head from '../../Head';
import PageHeroTitle from '../../PageHeroTitle';
import { Typography } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import { useTheme } from '@material-ui/styles';
import PageContext from '../../../contexts/page';
import Button from '@material-ui/core/Button';
import CollisionLink from '../../CollisionLink';
import { getResourceSelector } from '../../../store/resource/selectors';

const Wrapper = styled(Box)`
  width: 100%;
  padding: 40px 16px;

  ${({ theme }) => css`
    ${theme.breakpoints.down('sm')} {
      padding: 20px 16px;
    }
  `}
`;

const ButtonWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 16px;
    justify-content: center;
    margin-top: ${theme.spacing(7)}px;

    ${theme.breakpoints.down('sm')} {
      flex-direction: column;
      margin-top: ${theme.spacing(4)}px;
    }
  `}
`;

const CongratsPage = ({ ...props }) => {
  const theme = useTheme();
  const customer = useSelector(getResourceSelector)('customer');
  const { dispatchPageConfig } = useContext(PageContext);
  const [pageConfigDispatched, setPageConfigDispatched] = useState(false);
  const quizData = useSelector(getResourceSelector)('quiz');
  const selectedAnswer = quizData.selected_answer || {};

  useEffect(() => {
    if (!pageConfigDispatched) {
      dispatchPageConfig({
        type: 'reset-blacklist',
        pageSlug: 'congrats',
      });

      setPageConfigDispatched(true);
    }
  }, [dispatchPageConfig, pageConfigDispatched, setPageConfigDispatched]);

  if (
    !customer.fetching &&
    !customer.success &&
    Object.keys(selectedAnswer).length > 0
  ) {
    return <Redirect to="/" />;
  } else {
    return (
      <>
        <Head pageTitle="Congratulations" />
        <Wrapper theme={theme} textAlign="center" className="body">
          <PageHeroTitle title="Congratulations" />
          <Typography
            theme={theme}
            variant="subtitle1"
            component="p"
            style={{ marginBottom: '1rem' }}
          >
            You're in with a chance to win a big cash reward.
          </Typography>
          <Typography
            theme={theme}
            variant="subtitle1"
            component="p"
            style={{ marginBottom: '1.2rem' }}
          >
            For your good deed, you've been awarded a free Furphy Crisp
          </Typography>
          <ButtonWrapper theme={theme}>
            <Button
              variant="contained"
              size="large"
              component={CollisionLink(`/where-to-claim`)}
            >
              Redeem now
            </Button>
            <Button
              variant="outlined"
              size="large"
              component={CollisionLink(`/save-for-later`)}
            >
              Save for later
            </Button>
          </ButtonWrapper>
        </Wrapper>
      </>
    );
  }
};

export default CongratsPage;
